import React, { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import usePageMeta from "../Helpers/usePageMeta";

const NonDisclosureAgreement = () => {
  usePageMeta({
    title: "Non-Disclosure Agreement | TZ Creation",
    description: "TZ Creation's standard non-disclosure agreement for client projects.",
    path: "/non-disclosure-agreement",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <Breadcrumb
        parentpageName="Home"
        currentPageName="Non-Disclosure Agreement"
      />
      <section className="text-dark tnc_section section-gap pt-0">
        <div className="container py-3">
          <div className="row">
            <div className="col-12">
              <h2 className="mt-5 mb-2">NON-DISCLOSURE AGREEMENT</h2>
              <p>
                This Mutual Non-Disclosure Agreement (the "Agreement") is made
                and entered into; becomes effective upon the commencement of the
                any form of relationship by and between TZ Creation (hereinafter
                referred to as the "Disclosing Party") and "Company / Agent/
                Freelancer / Client / Employee" (hereinafter referred to as the
                "Recipient").
              </p>

              <p>
                WHEREAS, the Parties desire to explore and evaluate a potential
                business opportunity (the "Opportunity") and to protect the
                confidential and proprietary information disclosed between them;
              </p>

              <h2 className="mt-5 mb-2">1. Purpose</h2>
              <p>
                Parties have to disclose certain confidential, technical and
                business information in order to avail the GSP Services from the
                Company. To protect the said confidential information both the
                parties’ desires to sign this non-Disclosure agreement.
              </p>

              <h2 className="mt-5 mb-2">
                2. Disclosure of Confidential Information
              </h2>
              <p>
                Either party may disclose to the other party either orally or in
                any recorded medium, information comprising or relating to its /
                or its affiliates, parent, sister concerns group companies:
                techniques; schematics; designs; contracts; financial
                information; sales and marketing plans; business plans; clients;
                client data; business affairs; operations; strategies;
                inventions; methodologies; technologies; employees;
                subcontractors; pricing; service proposals; methods of
                operations; procedures; products and/or services ("Confidential
                Information”). Confidential Information shall include all
                nonpublic information furnished, disclosed or transmitted
                regardless of form.
              </p>

              <h2 className="mt-5 mb-2">3. Confidentiality</h2>
              <p>
                Either Party shall use the Confidential Information solely in
                furtherance of the actual or potential business relationship
                between the parties. The parties shall not use the Confidential
                Information in any way that is directly or indirectly
                detrimental to the other party or its subsidiaries or
                affiliates, and shall not disclose the Confidential Information
                to any unauthorized third party.
              </p>

              <p>
                Parties shall ensure that access to Confidential Information is
                granted only to those of its employees or agents
                (“Representatives”) who have a demonstrated need to know such
                information in order to carry out the business purpose of this
                Agreement. Prior to disclosing any Confidential Information to
                such Representatives, party shall inform them of the
                confidential nature of the information and their obligation to
                refrain from disclosure of the Confidential Information. Each
                party and its Representatives will take all reasonable measures
                to maintain the confidentiality of the Confidential Information,
                but in no event less than the measures it uses for its own
                information of similar type. Parties and its Representatives
                shall not disclose to any person including, without limitation,
                any corporation, sovereign, partnership, limited liability
                company, entity or individual (i) the fact that any
                investigations, discussions or negotiations are taking place
                concerning the actual or potential business relationship between
                the parties, (ii) that it has requested or received Confidential
                Information, or (iii) any of the terms, conditions or any other
                fact about the actual or potential business relationship.
              </p>

              <p>
                Each Party and its Representatives will immediately notify the
                other Party of any use or disclosure of the Confidential
                Information that is not authorized by this Agreement. Each Party
                and its Representatives will use its best efforts to assist the
                other Party in remedying any such unauthorized use or disclosure
                of the Confidential Information.
              </p>

              <p>
                Either Party shall implement and follow the rules as laid down
                in the Information Technology (Reasonable Security Practices and
                Procedures and Sensitive Personal Data or Information) Rules,
                2011.
              </p>

              <p>
                Either Party shall monitor the security practices, control
                processes and checks in place in respect of the Confidential
                Information on a regular basis and disclose any breaches in the
                security practices, control processes and checks in place to the
                other Party.
              </p>

              <p>
                The obligations contained in this Section 2 will not apply to
                the extent that either Party can demonstrate that the
                Confidential Information: (a) was part of the public domain at
                the time of disclosure or properly became part of the public
                domain, by publication or otherwise; (b) was rightfully acquired
                by Receiving Party prior to disclosure by Disclosing Party; (c)
                was independently developed by Receiving Party or its
                Representatives without reference to the Confidential
                Information; or (d) is required to be disclosed by a government
                agency or by a proper court of competent jurisdiction; provided,
                however, that Receiving Party and its Representatives shall
                provide Disclosing Party prompt prior written notice of such
                requirement, shall consult with and assist Disclosing Party in
                obtaining a protective order prior to such disclosure, and shall
                only disclose the portion of Confidential Information which it
                has been advised by written opinion of counsel is legally
                required to be disclosed and shall use its best efforts to
                obtain assurance that confidential treatment will be accorded
                such information if the protective order is not obtained or if
                Disclosing Party waives disclosure of such information.
              </p>

              <h2 className="mt-5 mb-2">
                4. Ownership of Materials/No Warranty
              </h2>
              <p>
                Each Party retains all rights, title and interest to its
                Confidential Information. No license under any trademark, patent
                or copyright, or application for same which are now or
                thereafter may be obtained by the other Party is either granted
                or implied by the disclosure of Confidential Information.
                Confidential Information is provided “as is” with all faults. In
                no event shall parties be liable for the accuracy or
                completeness of the Confidential Information.
              </p>

              <h2 className="mt-5 mb-2">
                5. Return of Confidential Information
              </h2>
              <p>
                Upon written request of either Party, Parties and its
                Representatives shall promptly return to the other Party all
                copies of Confidential Information in its possession including,
                without limitation, all copies of any analyses, compilations,
                studies or other documents prepared by Receiving Party or its
                Representatives containing or reflecting any Confidential
                Information. Either Party shall certify in writing that it and
                its Representatives have returned all such information to the
                other Party.
              </p>

              <h2 className="mt-5 mb-2">6. General</h2>
              <ol>
                <li>
                  This Agreement shall be governed by and construed in
                  accordance with the laws of India without regard to its conflicts
                  of law provisions.
                </li>
                <li>
                  Either Party agrees that the breach of the provisions of this
                  Agreement by any Party will cause the other Party an
                  irreparable damage for which recovery of money damages would
                  be inadequate. Either Party will, therefore, be entitled to
                  obtain timely injunctive relief to protect its rights under
                  this Agreement in addition to any and all remedies available
                  at law or in equity. Receiving Party and its Representatives
                  hereby irrevocably and unconditionally consent to submit to
                  the exclusive jurisdiction of the courts of Ahmedabad, Gujarat
                  for any actions, suits or proceedings arising out of or
                  relating to this Agreement and the transactions contemplated,
                  and further agree that service of any process, summons, notice
                  or document by registered mail or tracked courier service to
                  the address set forth above shall be effective service of
                  process for any action, suit or proceeding brought against
                  Receiving Party and its Representatives in any such court.
                </li>
                <li>
                  Neither party may assign any of its rights or obligations
                  under this Agreement without the prior written consent of the
                  other party. This Agreement shall be binding upon and inure to
                  the benefit of the parties’ permitted successors and assigns.
                </li>
                <li>
                  This Agreement may be amended or supplemented only by a
                  writing that is signed by duly authorized representatives of
                  both parties.
                </li>
                <li>
                  No term or provision hereof will be considered waived by
                  either party, and no breach excused by it, unless such waiver
                  or consent is in writing signed an authorized representative
                  of the non-breaching party. No consent to, or waiver of, a
                  breach by a party, whether express or implied, will constitute
                  a consent to, waiver of, or excuse of any other, different, or
                  subsequent breach.
                </li>
                <li>
                  If any part of this Agreement is found invalid or
                  unenforceable, that part will be amended to achieve as nearly
                  as possible the same economic and legal effect as the original
                  provision and the remainder of this Agreement will remain in
                  full force
                </li>
                <li>
                  This Agreement constitutes the entire agreement between the
                  parties relating to this subject matter and supersedes all
                  prior or simultaneous representations, discussions,
                  negotiations, and agreements, whether written or oral.
                </li>
                <li>
                  This agreement may be executed in two counterparts, each of
                  which shall be deemed to be an original but all of which
                  together shall constitute one and the same agreement.
                </li>
              </ol>

              <br />

              <p className="font-w600 f-s-14">
                Engaging with TZ Creation Service or establishing any form of
                relationship with TZ Creation constitutes automatic acceptance
                of this NDA.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default NonDisclosureAgreement;
